import { FC, ReactNode, useState } from 'react';
import {
  Box,
  Button,
  ButtonProps,
  ButtonSkin,
  Heading,
  IconButton,
  Popover,
  PopoverProps,
  Tooltip,
} from 'wix-style-react';
import * as Icons from 'wix-ui-icons-common';
import { classes } from './DeleteConfirmation.st.css';

type DeleteConfirmationProps = {
  buttonText?: ReactNode | string;
  confirmText?: string;
  successClick: () => void;
  placement?: PopoverProps['placement'];
  tooltipContent?: string;
  skin?: ButtonSkin;
  priority?: ButtonProps['priority'];
  className?: string;
};

export const DeleteConfirmation: FC<DeleteConfirmationProps> = ({
  buttonText,
  confirmText = 'Are you sure?',
  successClick,
  placement = 'right',
  tooltipContent = 'content',
  skin = 'destructive',
  priority = 'primary',
  className,
}) => {
  const [shown, setShown] = useState(false);
  return (
    <Popover
      style={{ width: '100%' }}
      showArrow
      zIndex={9999999999}
      shown={shown}
      appendTo="window"
      placement={placement}
    >
      <Popover.Element>
        <Tooltip content={tooltipContent}>
          {!buttonText ? (
            <IconButton onClick={() => setShown(true)} className={classes.delete}>
              <Icons.Delete />
            </IconButton>
          ) : (
            <div style={{ width: '100%' }} className={className} onClick={() => setShown(true)}>
              {buttonText}
            </div>
          )}
        </Tooltip>
      </Popover.Element>
      <Popover.Content>
        <Box align="center" width={'100%'} paddingTop={2}>
          <Heading appearance="H5">{confirmText}</Heading>
        </Box>
        <Box direction="horizontal" gap={2} margin={3} paddingBottom={2}>
          <Button
            size="small"
            onClick={() => {
              setShown(false);
              successClick();
            }}
          >
            Yes
          </Button>
          <Button priority="secondary" size="small" onClick={() => setShown(false)}>
            No
          </Button>
        </Box>
      </Popover.Content>
    </Popover>
  );
};
